import { CSSVars } from '@/styles/styles.config';
import styled from 'styled-components';

export const StyledDiv = styled.div`
	.search-box {
		z-index: 10;
		/* padding: 20px; */

		.search-box-wrapper {
			position: relative;
			max-width: 720px;
			margin: 0 auto;
		}

		.ais-SearchBox-form {
			display: flex;
			justify-content: center;

			form {
				position: relative;
			}

			input[type='text'],
			input[type='search'] {
				border: 1px solid rgba(255, 255, 255, 0.1);
				border-radius: 8px;
				background: ${CSSVars.gray700};
				font-size: 16px;
				color: ${CSSVars.gray100};
				font-weight: 500;
				font-family: ${CSSVars.primaryFont};
				width: 100%;
				transition: all 0.2s ease;
				background-image: url("data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.34938 1.60176C7.21356 -0.533921 3.73735 -0.533921 1.60152 1.60176C-0.53384 3.73791 -0.53384 7.21343 1.60152 9.34958C3.50353 11.251 6.46581 11.4547 8.60025 9.96996C8.64516 10.1825 8.74795 10.3852 8.91324 10.5505L12.0237 13.6608C12.477 14.1131 13.2094 14.1131 13.6604 13.6608C14.1132 13.208 14.1132 12.4756 13.6604 12.0242L10.5499 8.913C10.3856 8.7491 10.1823 8.64586 9.96981 8.60095C11.4556 6.46619 11.2519 3.50457 9.34938 1.60176ZM8.36736 8.36761C6.77278 9.96209 4.17766 9.96209 2.58355 8.36761C0.989897 6.77314 0.989897 4.17866 2.58355 2.58419C4.17766 0.990178 6.77278 0.990178 8.36736 2.58419C9.96194 4.17866 9.96194 6.77314 8.36736 8.36761Z' fill='%23B4B4B4'/%3E%3C/svg%3E%0A");
				background-repeat: no-repeat;
				background-position: 13px 45%;
				padding: 10px 20px 10px 35px;
				font-size: ${CSSVars.fontSizeSM};
				border-radius: 5px;
				font-weight: 300;
				max-width: 440px;

				&:focus {
					border-color: ${CSSVars.white};
					color: #fff;
				}
			}

			button {
				background: none;
				position: absolute;
				left: 15px;
				top: 50%;
				padding: 0;
				margin: 1px 0 0;
				transform: translateY(-50%);
				border: none;
				color: ${CSSVars.gray200};
				font-size: 20px;
				transition: all 0.2s ease;

				&[type='reset'] {
					left: auto;
					right: 15px;
					font-size: 20px;
				}

				&:hover {
					color: ${CSSVars.white};
					cursor: pointer;
				}
			}

			input[type='search']::-webkit-search-decoration,
			input[type='search']::-webkit-search-cancel-button,
			input[type='search']::-webkit-search-results-button,
			input[type='search']::-webkit-search-results-decoration {
				-webkit-appearance: none;
			}

			select {
				position: absolute;
				right: 0;
				top: 0;
				height: 100%;
				width: 20%;
				border-radius: 0 50em 50em 0;
				background: none;
				text-align: center;
				color: ${CSSVars.gray200};
				border: none;
			}
		}

		.autocomplete-box {
			position: absolute;
			left: 50%;
			top: 100%;
			width: 100%;
			max-width: 90vw;
			transform: translateX(-50%) translateY(10px);
			background: ${CSSVars.gray600};
			max-height: 40vh;
			max-width: 100%;
			max-width: 440px;
			overflow-x: hidden;
			overflow-y: auto;
			border-radius: 3px;
			box-shadow: 0 5px 10px rgba(255, 255, 255, 0.05);
			z-index: 10;
			text-align: left;

			h6 {
				padding: 10px 15px;
				z-index: 1;
				color: #fff;
				font-weight: 600;

				span {
					color: ${CSSVars.gray200};
					font-size: 70%;
					font-weight: 200;
					margin-left: 10px;
				}

				&:first-of-type {
					border-radius: 3px 3px 0 0;
				}

				&:not(:first-of-type) {
					// margin-top: 20px;
					z-index: 2;
				}
			}

			.ais-Hits-list {
				margin: 0 0 10px;
			}

			.autocomplete-item {
				padding: 5px 10px;
				font-size: 14px;
				position: relative;
				flex-wrap: nowrap;
				min-height: 30px;
				line-height: 18px;
				display: flex;
				gap: 5px;
				align-items: center;

				&:hover {
					background: ${CSSVars.gray500};
				}

				img {
					width: 30px;
					height: 30px;
					object-fit: contain;
				}

				.meta {
					margin: 0 0 0 10px;
				}

				a {
					position: absolute;
					left: 0;
					top: 0;
					width: 100%;
					height: 100%;
					z-index: 1;
				}
			}
		}
	}
`;
